<app-navbar-style-one></app-navbar-style-one>

<!-- <div id="adsCarousel" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-indicators">
      <button *ngFor="let ad of ads; let i = index" 
              [attr.data-bs-target]="'#adsCarousel'" 
              [attr.data-bs-slide-to]="i" 
              [class.active]="i === 0"></button>
    </div>
  
    <div class="carousel-inner">
      <div *ngFor="let ad of ads; let i = index" 
           class="carousel-item" 
           [class.active]="i === 0"
           [style.background-image]="'url(' + ad.image + ')'">
        <div class="d-table w-100 h-100">
          <div class="d-table-cell align-middle">
            <div class="container">
              <div class="slider-content">
                <h1 style="color: #fff;margin-top: 40%;text-align: center;">وصلة | اطلب الطعام والبقالة اون لاين من مطاعم ومحلات التوصيل في مصر</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <button class="carousel-control-prev" type="button" data-bs-target="#adsCarousel" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#adsCarousel" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
</div> -->

<!-- <div class="title-section" style="background-color: #0d0f1cf0;">
    <div class="container-fluid">
        <div class="row title-row">
            <div class="col-lg-12 text-center px-0">
                <h2 class="pb-3 mb-5" style="color: #fff;text-align: center;">وصلة</h2>
                <img class="img-fluid home-img" style="float: left;" src="../../../../assets/img/Wiesmac.webp" alt="Images">
                <img class="img-fluid home-img" style="float: right;" src="../../../../assets/img/Grocery-bag-with-items-spilling-out-700-new.webp" alt="Images">
                <h3 style="color: #fff;text-align: center;">اطلب الطعام والبقالة اون لاين من مطاعم ومحلات التوصيل في مصر</h3>
            </div>
        </div>
    </div>
</div> -->

<section class="category-area pt-100 pb-70" id="categorySection">
    <div class="container">
        <div id="departement" class="section-title text-center">
            <h3>الاقسام</h3>
            <!-- <h2>استخدم البحث عن طريق الاقسام</h2> -->
        </div>

        <div class="row category-bg">
            <div class="col-lg-4 col-sm-6" *ngFor="let category of categories;let i = index;trackBy: trackById">
                <div class="category-card">
                    <a [href]="'category/' + category.id + '/' + category.name">
                        <img src="{{category.avatar}}" width="110" alt="{{category.name}}">
                    </a>
                    <a [href]="'category/' + category.id + '/' + category.name"><h3>{{category.name}}</h3></a>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="application-area pt-100 pb-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5">
                <div class="application-img">
                    <!-- <img src="assets/img/mobile.webp" style="border-radius: 35px;" alt="صورة التطبيق"> -->
                    <img _ngcontent-ng-c2444856136="" 
                        src="assets/img/mobile.webp" 
                        alt="صورة التطبيق" 
                        style="border-radius: 35px;"
                        width="600" 
                        height="400"
                        fetchpriority="high"
                        loading="eager">
                </div>
            </div>

            <div class="col-lg-7">
                <div class="application-content">
                    <div class="section-title">
                        <span>حمل التطبيق الآن</span>
                        <h2>استمتع بتجربة أفضل مع تطبيقنا</h2>
                        <p>قم بتنزيل تطبيقنا للاستمتاع بخدمة أسهل وأسرع لعرض القوائم وتقديم الطلبات. تجربة رائعة بانتظارك!</p>
                    </div>

                    <div class="application-btn">
                        <a href="#" class="application-play-btn">
                            <img src="assets/img/google-play.svg" alt="svg">
                            <div class="btn-content">
                                <span>تطبيق أندرويد على</span>
                                <h3>Google Play</h3>
                            </div>
                        </a>
                        <a href="#" class="application-play-btn">
                            <img src="assets/img/company.svg" alt="svg">
                            <div class="btn-content">
                                <span>حمّل من</span>
                                <h3>App Store</h3>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <section class="place-list-area pb-70">
    <div class="container-fluid">
        <div class="section-title text-center">
            <span>تصفح العروض</span>
            <h2>آخر عروضنا</h2>
        </div>

        <div class="place-slider owl-carousel owl-theme pt-45 row d-flex">
            <div class="col-lg-4 place-list-item" *ngFor="let offer of offers;let i = index;trackBy: trackById">
                <div class="images">
                    <a routerLink="/listing-details/{{offer.id}}" class="images-list">
                        <img src="{{offer.avatar || 'assets/img/place-list/place-list1.jpg'}}" alt="{{offer.name}}">
                    </a>
                    

                    <div class="place-status bg-dark-orange">
                        <a routerLink="/listing-details/{{offer.id}}"><h3>خصم</h3></a>
                    </div>

                    <div class="place-tag">
                        <ul>
                            <li><a routerLink="/"><i class="flaticon-like"></i></a></li>
                            <li><a routerLink="/"><i class="flaticon-workflow"></i></a></li>
                        </ul>
                        <span><a routerLink="/"><span *ngIf="offer.offer.type == 'percentage'">%</span> <span *ngIf="offer.offer.type == 'discount'">ج.م</span> {{offer.offer.value}} </a></span>
                    </div>
                </div>

                <div class="content">
                    <a routerLink="/listing-details/{{offer.id}}"><h3>{{offer.name}}</h3></a> 
                    <p><i class="bx bx-money"></i> {{offer.types[0].price}} ج.م</p>
                    <ul class="place-rating">
                        <li><a routerLink="/">{{offer.rate}}</a></li>
                        <li>
                            <i *ngFor="let star of [].constructor(offer.rate); let j = index" class="bx bxs-star"></i>
                            <i *ngFor="let emptyStar of [].constructor(5 - offer.rate); let k = index" class="bx bxs-star icon-color"></i>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section> -->

<section class="process-area process-bg pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span>العملية</span>
            <h2>تعرف على كيفية العمل</h2>
            <p>نقدم لك طريقة سهلة لاستكشاف قوائم الطعام وطلب وجبتك بكل سهولة </p>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-sm-6">
                <div class="process-card">
                    <i class="flaticon-position icon-bg"></i>
                    <h3>استكشف قوائم الطعام المتوفرة</h3>
                    <p>اكتشف أماكن مميزة وخيارات لذيذة تناسب ذوقك.</p>
                    <div class="process-number">1</div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="process-card">
                    <i class="flaticon-to-do-list icon-bg"></i>
                    <h3>اختر ما تريد طلبه</h3>
                    <p>استعرض القوائم واختر أطباقك المفضلة من المطاعم المميزة.</p>
                    <div class="process-number active">2</div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 offset-sm-3 offset-lg-0">
                <div class="process-card">
                    <i class="flaticon-box icon-bg"></i>
                    <h3>اطلب وجبتك بسهولة</h3>
                    <p>أكمل طلبك بخطوات بسيطة واستمتع بوجبتك في وقت قصير.</p>
                    <div class="process-number">3</div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="city-area ptb-100"> 
    <div class="container">
        <div class="section-title text-center">
            <span>المدن</span>
            <h2>استكشف أفضل المدن في المنطقة</h2>
            <p>نوفر لك فرصة لاكتشاف المدن المميزة وخيارات الطعام المتنوعة بسهولة </p>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-md-6" *ngFor="let city of cities;let i = index">
              <div class="city-item">
                <a class="city-img">
                  <img src="assets/img/City skyline-bro.png" alt="{{ city.name }}">
                </a>
                <div class="city-content">
                  <div class="city-text">
                    <a><h3  style="color: var(--mainColor) !important;">{{ city.name }}</h3></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
    </div>
</section> -->

<!-- <div class="video-area video-area-bg">
    <div class="container">
        <div class="video-content">
            <h2>هل أنت مستعد لبدء رحلتك؟</h2>
            <p>انضم إلينا واستكشف أفضل الوجهات مع خدماتنا المميزة.</p>
            <a href="#departement" class="default-btn border-radius">استكشف المزيد <i class='bx bx-right-arrow-alt'></i></a>
        </div>
    </div>
</div> -->

<!-- <div class="counter-area">
    <div class="container">
        <div class="counter-bg">
            <div class="row">
                <div class="col-lg-3 col-sm-6 col-md-3">
                    <div class="single-counter">
                        <h3>15000</h3>
                        <span>عدد الزوار الجدد أسبوعيًا</span>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-3">
                    <div class="single-counter">
                        <h3>2500</h3>
                        <span>عدد الزوار الجدد يوميًا</span>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-3">
                    <div class="single-counter">
                        <h3>500</h3>
                        <span>الجوائز المميزة التي حصلنا عليها</span>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-3">
                    <div class="single-counter">
                        <h3>400</h3>
                        <span>عدد الإضافات الجديدة أسبوعيًا</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!-- <div class="place-area pt-100 pb-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-6">
                <div class="section-title mb-45">
                    <span>أفضل البائعين</span>
                    <h2>تعرف على أكثر البائعين شهرة</h2>
                </div>
            </div>

            <div class="col-lg-5 col-md-6">
                <div class="place-btn">
                    <a routerLink="/listing" class="default-btn border-radius">عرض جميع البائعين <i class='bx bx-plus'></i></a>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let vendor of vendors;let i = index">
                <div class="place-card">
                    <a routerLink="/listing-details/{{vendor.id}}" class="place-images"><img src="{{vendor.avatar}}" alt="Images"></a>

                    <div class="content">
                        <a routerLink="/listing-details/{{vendor.id}}"><h3>{{vendor.name }}</h3></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->



<!-- <section class="testimonial-area pb-70">
    <div class="container-fluid">
        <div class="section-title text-center">
            <span>Testimonials</span>
            <h2>What Our Clients Say</h2>
        </div>

        <div class="testimonial-slider owl-carousel owl-theme">
            <div class="testimonial-item testimonial-item-bg">
                <h3>Sanaik Tubi</h3>
                <span>Arbon Restaurant</span>
                <p>Roinin ipsum dolor sit amet, consectetur adipisicing  sit ut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <div class="testimonial-top">
                    <i class='bx bxs-quote-left'></i>
                </div>
            </div>

            <div class="testimonial-item testimonial-item-bg">
                <h3>Oli Rubion</h3>
                <span>Rubion Inc</span>
                <p>Roinin ipsum dolor sit amet, consectetur adipisicing  sit ut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <div class="testimonial-top">
                    <i class='bx bxs-quote-left'></i>
                </div>
            </div>

            <div class="testimonial-item testimonial-item-bg">
                <h3>Mashrof Ruin</h3>
                <span>Pice Cafe</span>
                <p>Roinin ipsum dolor sit amet, consectetur adipisicing  sit ut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <div class="testimonial-top">
                    <i class='bx bxs-quote-left'></i>
                </div>
            </div>

            <div class="testimonial-item testimonial-item-bg">
                <h3>Sanaik Tubi</h3>
                <span>Arbon Restaurant</span>
                <p>Roinin ipsum dolor sit amet, consectetur adipisicing  sit ut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <div class="testimonial-top">
                    <i class='bx bxs-quote-left'></i>
                </div>
            </div>

            <div class="testimonial-item testimonial-item-bg">
                <h3>Sanaik Tubi</h3>
                <span>Arbon Restaurant</span>
                <p>Roinin ipsum dolor sit amet, consectetur adipisicing  sit ut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                <ul class="rating">
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                    <li><i class='bx bxs-star'></i></li>
                </ul>
                <div class="testimonial-top">
                    <i class='bx bxs-quote-left'></i>
                </div>
            </div>
        </div>
    </div>
</section> -->

<app-footer-style-one></app-footer-style-one>